import { Document, Page, View } from '@react-pdf/renderer';

import { VehicleInspectionReportExtraDetailsRead } from 'src/common/external/bambi-api/bambiApi';
import { commonStyles } from 'src/common/pdf/common.styles';

import { VehicleInspectionReportDriverSection } from './components/VehicleInspectionReportDriverSection';
import { VehicleInspectionReportHeader } from './components/VehicleInspectionReportHeader';
import { VehicleInspectionReportItemsSection } from './components/VehicleInspectionReportItemsSection';
import { VehicleInspectionReportOutcomeSection } from './components/VehicleInspectionReportOutcomeSection';
import { VehicleInspectionReportVehicleSection } from './components/VehicleInspectionReportVehicleSection';

interface VehicleInspectionReportDocumentProps {
  organizationName: string;
  logo?: string;
  inspection: VehicleInspectionReportExtraDetailsRead;
}
export function VehicleInspectionReportDocument({
  organizationName,
  logo,
  inspection,
}: VehicleInspectionReportDocumentProps) {
  return (
    <Document>
      <Page
        orientation="portrait"
        size="A4"
        style={[{ padding: 4 }, commonStyles.textSm]}
      >
        <VehicleInspectionReportHeader
          inspectionDate={inspection.created_at}
          organizationName={organizationName}
          logo={logo}
        />
        <View style={{ flexDirection: 'column', gap: 8, marginTop: 8 }}>
          <View
            style={[
              {
                flexDirection: 'row',
                gap: 8,
                justifyContent: 'space-evenly',
              },
              commonStyles.textMd,
            ]}
          >
            <VehicleInspectionReportVehicleSection
              vehicle={inspection.vehicle}
            />
            <VehicleInspectionReportDriverSection
              driver={inspection.membership}
            />
          </View>
          <VehicleInspectionReportItemsSection data={inspection.report_json} />
          <VehicleInspectionReportOutcomeSection
            reportItems={inspection.report_json}
            signatures={inspection.signatures_as_base64}
          />
        </View>
      </Page>
    </Document>
  );
}
